module.exports = __webpack_public_path__ + "static/media/th.2404ec80.svg";